"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var csod = require("player-core");
var React = require("react");
var Panel_1 = require("player-layout-controls/controls/Panel");
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
var GridCol_1 = require("player-layout-controls/controls/GridCol");
var Text_1 = require("player-common-controls/controls/Text");
var Hyperlink_1 = require("player-common-controls/controls/Hyperlink");
var filter_sections_1 = require("@csod/filter-sections");
var player_toggle_1 = require("player-toggle");
var JobSearchFilter = (function (_super) {
    __extends(JobSearchFilter, _super);
    function JobSearchFilter(props) {
        return _super.call(this, props) || this;
    }
    JobSearchFilter.prototype.componentDidMount = function () {
        this.setupAccessibility();
    };
    JobSearchFilter.prototype.componentDidUpdate = function () {
        this.setupAccessibility();
    };
    JobSearchFilter.prototype.setupAccessibility = function () {
        var dataTag = "p-filter-collapsible-link";
        var sections = document.querySelectorAll("[data-tag=\"" + dataTag + "\"]");
        for (var i = 0; i < sections.length; i++) {
            var section = sections[i];
            var title = section.getAttribute("title");
            if (!title)
                continue;
            var label = csod.locales.get(title, title) + " " + csod.locales.get("Expand/Collapse", "Expand/Collapse") + " " + csod.locales.get("List", "List");
            section.setAttribute("aria-label", label);
            section.setAttribute("role", "button");
            var container = section.parentElement;
            if (container) {
                var radioGroups = container.querySelectorAll('.p-radio-group[role="radiogroup"]');
                for (var j = 0; j < radioGroups.length; j++) {
                    var radioGroup = radioGroups[j];
                    if (!radioGroup.hasAttribute('aria-label') && !radioGroup.hasAttribute('aria-labelledby')) {
                        radioGroup.setAttribute('aria-label', csod.locales.get(title, title));
                    }
                }
            }
        }
        var clearButtonNodes = document.querySelectorAll('.p-icon-button[title="Clear"]');
        for (var i = 0; i < clearButtonNodes.length; i++) {
            clearButtonNodes[i].setAttribute("tabIndex", "0");
            clearButtonNodes[i].addEventListener('focus', function (e) {
                e.currentTarget.style.outline = '2px solid';
                e.currentTarget.style.outlineOffset = '2px';
            });
            clearButtonNodes[i].addEventListener('keydown', function (ev) {
                var e = ev;
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    e.currentTarget.click();
                }
            });
        }
    };
    JobSearchFilter.prototype.render = function () {
        var _a = this.props, tag = _a.tag, filters = _a.filters, filtersText = _a.filtersText, resetText = _a.resetText, showMobileFilter = _a.showMobileFilter, showMobileText = _a.showMobileText, showMobileChecked = _a.showMobileChecked;
        return (React.createElement("div", { className: "p-jobsearchfilter", "data-tag": tag },
            React.createElement(Panel_1.Panel, { backgroundColor: "White" },
                React.createElement(Panel_1.Panel, { paddingAll: "Medium" },
                    React.createElement(GridLayout_1.GridLayout, { colMainAxisAlignment: "SpaceBetween", colCrossAxisAlignment: "Bottom" },
                        React.createElement(GridCol_1.GridCol, null,
                            React.createElement(Text_1.Text, { text: filtersText, size: "Xlarge", weight: "SemiBold" })),
                        React.createElement(GridCol_1.GridCol, null,
                            React.createElement(Hyperlink_1.Hyperlink, { text: resetText, type: "Action", onClick: this.props.onResetFilters, role: "button", ariaLabel: csod.locales.get("Reset Filters", "Reset Filters") })))),
                React.createElement(Panel_1.Panel, { borderStyleTop: "Solid", borderWidthTop: "Xsmall", borderColorTop: "Grey70" },
                    React.createElement(filter_sections_1.default, { filters: filters, handleCollapsibleClick: this.props.handleCollapsibleClick, onRadioButtonClick: this.props.onRadioButtonClick, onCheckboxClick: this.props.onCheckboxClick, onInputChange: this.props.onInputChange, onDropdownSelect: this.props.onDropdownSelect })),
                showMobileFilter &&
                    React.createElement(Panel_1.Panel, { paddingAll: "Medium" },
                        React.createElement(player_toggle_1.default, { label: showMobileText, showLabel: true, checked: showMobileChecked, onChange: this.props.onShowMobileChecked })))));
    };
    return JobSearchFilter;
}(React.Component));
JobSearchFilter.defaultProps = {
    tag: null,
    filters: "",
    filtersText: "",
    resetText: "",
    showMobileFilter: "",
    showMobileText: "",
    showMobileChecked: "",
    handleCollapsibleClick: function () { },
    onRadioButtonClick: function () { },
    onCheckboxClick: function () { },
    onInputChange: function () { },
    onShowMobileChecked: function () { },
    onResetFilters: function () { },
    onDropdownSelect: function () { }
};
exports.JobSearchFilter = JobSearchFilter;

if(!window["__LOCALES__"]) window["__LOCALES__"] = {}; window["__LOCALES__"]["JobSearchFilter"] = [];


//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobSearchFilter/JobSearchFilter.js
// module id = 326
// module chunks = 0